import regularLogo from '../assets/images/logo.png';

const getLogo = (): string => {
  return regularLogo
}

export default getLogo
